"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _localStorageMgr = _interopRequireDefault(require("./localStorageMgr"));

var _logger = require("./logger");

var _awaitCMPLoad = _interopRequireDefault(require("./awaitCMPLoad"));

var TCF_LOCAL_DATA_KEY = 'tabCMP.tcfv2.data';
var USP_LOCAL_DATA_KEY = 'tabCMP.usp.data';
var USP_PING_LOCAL_DATA_KEY = 'tabCMP.uspPing.data'; // Get the TCF and USP data from Quantcast Choice and
// store them in local storage. This gives our stub
// functions quicker access to the user's choices.

var updateStoredPrivacyData =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee() {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return (0, _awaitCMPLoad.default)();

          case 3:
            _context.next = 9;
            break;

          case 5:
            _context.prev = 5;
            _context.t0 = _context["catch"](0);
            (0, _logger.logDebugging)("Could not update stored privacy data.");
            return _context.abrupt("return");

          case 9:
            try {
              (0, _logger.logDebugging)("Syncing local storage TCF and USP data."); // TCF/GDPR

              if (typeof window.__tcfapi === 'function') {
                window.__tcfapi('getTCData', 2, function (tcData, success) {
                  if (success && tcData) {
                    _localStorageMgr.default.setItem(TCF_LOCAL_DATA_KEY, JSON.stringify(tcData));

                    (0, _logger.logDebugging)("Successfully updated TCF local storage data. Value:", tcData);
                  } else {
                    (0, _logger.logDebugging)("Could not update TCF local storage data. The CMP errored and provided these data:", tcData);
                  }
                });
              } else {
                (0, _logger.logError)(new Error("[tab-cmp] Could not update TCF local storage data. window.__tcfapi is not defined."));
              } // USP/CCPA


              if (typeof window.__uspapi === 'function') {
                window.__uspapi('uspPing', 1, function (uspPingResponse, status) {
                  if (status) {
                    _localStorageMgr.default.setItem(USP_PING_LOCAL_DATA_KEY, JSON.stringify(uspPingResponse));

                    (0, _logger.logDebugging)("Successfully updated USP ping local storage data. Value:", uspPingResponse);

                    window.__uspapi('getUSPData', 1, function (uspData, success) {
                      if (success && uspData) {
                        _localStorageMgr.default.setItem(USP_LOCAL_DATA_KEY, JSON.stringify(uspData));

                        (0, _logger.logDebugging)("Successfully updated USP local storage data. Value:", uspData);
                      } else {
                        (0, _logger.logDebugging)("Could not update USP local storage data. The CMP errored and provided these data:", uspData);
                      }
                    });
                  } else {
                    (0, _logger.logDebugging)("Could not update USP local storage data. The CMP errored.");
                  }
                });
              } else {
                (0, _logger.logError)(new Error("[tab-cmp] Could not update USP local storage data. window.__uspapi is not defined."));
              }
            } catch (e) {
              (0, _logger.logError)(e);
            }

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 5]]);
  }));

  return function updateStoredPrivacyData() {
    return _ref.apply(this, arguments);
  };
}();

var _default = updateStoredPrivacyData;
exports.default = _default;